import { KeyButton } from "../../keyButton/KeyButton"
import './VinylsHintsMenu.css'
import { useStore } from "../../../store/store"
import { translations } from "../../../configs/translations"

export const VinylsHintsMenu = () => {
    const language = useStore(state => state.language) as keyof typeof translations;
    const t = translations[language];

    const hints: {text: string, keys: string[]}[] = [
        {text: t.vinyls_hint_move_items, keys: ["⭡", "⭣", "⭠", "⭢"]},
        {text: t.vinyls_hint_change_editor_modes, keys: ["Q", "W", "E", "R"]},
        {text: t.vinyls_hint_change_faster_slower, keys: ["Shift", "Alt"]},
        {text: t.vinyls_hint_change_z_index, keys: ["+", "-"]},
        {text: t.vinyls_hint_delete, keys: ["D"]},
        {text: t.vinyls_hint_copy, keys: ["C"]},
        {text: t.vinyls_hint_select_all, keys: ["Shift+A"]},
        {text: t.vinyls_hint_delete_all, keys: ["Shift+D"]},
        {text: t.vinyls_hint_select_many, keys: ["Alt"]},
        {text: t.vinyls_hint_create_group, keys: ["J"]},
        {text: t.vinyls_hint_delete_group, keys: ["Shift+J"]},
        {text: t.vinyls_hint_hide_menu, keys: ["Shift+Z"]},
    ]

    return (
        <div className="vinyls-hints-menu">
            
            {hints.map((hint, index) => (
                <div className="vinyls-hint" key={index}>
                    <p>{hint.text}</p>
                    <div className="vinyls-hint-keys">
                        {hint.keys.map((key, index) => (
                            <KeyButton text={key} key={index} />
                        ))}
                    </div>
                </div>
            ))}


        </div>
    )
}